module.exports = __webpack_public_path__ + "static/media/fruits_16.d0d67c38.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_16.csv
// module id = 680
// module chunks = 0